import React, { ComponentType, useEffect, useState } from "react";
import {
  Box,
  Heading,
  Text,
  VStack,
  Spinner,
  Alert,
  AlertIcon,
  HStack,
  Icon,
} from "@chakra-ui/react";
import { FaRobot } from "react-icons/fa";
import { getAISuggestionForLead } from "../hooks/ai_insights";
import { Lead } from "../utils/types";

interface LeadAIProps {
  orgId: string | null;
  lead: Lead | null;
  leadId: number | string | null;
}

const LeadSuggestions: React.FC<LeadAIProps> = ({ orgId, lead }) => {
  const [loading, setLoading] = useState(true);
  const [suggestion, setSuggestion] = useState('');
  const [error, setError] = useState<string | null>(null);
  const createdAt = lead?.created_at;
  const interestDisplay = lead?.level_of_interest_display;
  const nextFollowUp = lead?.next_follow_up;
  const stage = lead?.stage;

  useEffect(() => {
    const fetchSuggestions = async () => {
      setLoading(true);
      setError(null);
      try {
        let context = `This is a ${stage} customer added on ${createdAt} and their next follo up date is ${nextFollowUp} 
            their level of interest is ${interestDisplay}. 
            What would be the best next step to handle this customer? Provide some tips and advice 
            on how to handle the customer and sales process to the sales person.
            `;
        const response = await getAISuggestionForLead(context,orgId||'')
        setSuggestion(response?.data?.suggestion);
        console.log('context', context);
        console.log('response', response);
      } catch (err: any) {
        setError("Failed to fetch AI suggestions.");
      } finally {
        setLoading(false);
      }
    };
    fetchSuggestions();
  }, [createdAt, interestDisplay, nextFollowUp, orgId, stage]);

  return (
    <Box
      mt={14}
      p={5}
      bg="gray.30"
      border="1px solid"
      borderColor="gray.100"
      borderRadius="xl"
      boxShadow="sm"
      w="full"
    >
      <HStack spacing={3} mb={4}>
        <Icon as={FaRobot as ComponentType} boxSize={6} color="green.500" />
        <Heading size="md" color="green.700">
          Suggestions
        </Heading>
      </HStack>

      {loading ? (
        <HStack>
          <Spinner size="md" color="green.500" />
          <Text fontSize="sm" color="gray.600">
            Fetching smart suggestions...
          </Text>
        </HStack>
      ) : error ? (
        <Alert status="error" variant="subtle" borderRadius="md">
          <AlertIcon />
          <Text fontSize="sm">{error}</Text>
        </Alert>
      ) : !suggestion ? (
        <Text fontSize="sm" color="gray.500" fontStyle="italic">
          No suggestions available right now.
        </Text>
      ) : (
        <VStack align="start" spacing={3}>
          <Text fontSize="sm" color="gray.700" whiteSpace="pre-wrap">
            {suggestion}
          </Text>
        </VStack>
      )}
    </Box>
  );
};

export default LeadSuggestions;
